module.exports = __webpack_public_path__ + "img/email.0c606db1.svg";